<template>
  <el-dialog
    id="CancelRefund"
    title="取消退款"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="450px">
    <el-row>
      <el-col :span="24"><span class="label">退款状态：</span><span class="status">{{statusTag(apply.status)}}</span></el-col>
      <el-col :span="24"><span class="label">退款订单：</span>{{apply.orderNum}}</el-col>
      <el-col :span="24"><span class="label">退款原因：</span>{{apply.reason}}</el-col>
      <el-col :span="24"><span class="label">退款金额：</span>{{apply.totalPrice}}</el-col>
      <el-col :span="24"><span class="label">申请时间：</span>{{apply.addTime}}</el-col>
      <el-col :span="24"><span class="label">备注：</span>{{apply.remark}}</el-col>
    </el-row>
    <a class="cancelBtn" @click="submit">取消退款</a>
  </el-dialog>
</template>

<script>
  import axios from 'axios'

  export default {
    name: "cancel-refund",
    data() {
      return {
        visible: false,
        orderId: '',
        apply: '',
        statusList: [
          {
            status: 0,
            label: '未申请'
          },
          {
            status: 1,
            label: '待审核'
          },
          {
            status: 2,
            label: '申请成功'
          },
          {
            status: 3,
            label: '申请失败'
          },
          {
            status: 4,
            label: '处理完成'
          },
          {
            status: 5,
            label: '处理失败'
          },
          {
            status: 9,
            label: '取消申请'
          }
        ]
      }
    },
    computed: {
      statusTag() {
        return function (code) {
          return (this.statusList.find(e => e.status === code) || {label: '暂无'}).label
        }
      }
    },
    methods: {
      //初始化
      init(id) {
        this.orderId = id
        this.visible = true
        axios.get("/re/appt/" + this.orderId).then((res) => {
          if (res.data.code === 0) {
            this.apply = res.data.apply
          }
        })
      },
      submit() {
        axios.post("/re/appt/cancel", {
          orderNum: this.apply.orderNum,
          orderPlatform: 1
        }).then((res) => {
          if (res.data.code === 0) {
            this.$message.success('操作成功')
            this.visible = false
            this.$emit('refreshDataList')
          }
        })
      }
    }
  }
</script>

<style scoped>
  #CancelRefund >>> .el-dialog {
    border-radius: 10px;
  }

  #CancelRefund >>> .el-dialog__header {
    text-align: center;
  }

  #CancelRefund >>> .el-dialog__title {
    color: #000000;
    font-size: 16px;
  }

  #CancelRefund >>> .el-dialog__body {
    padding: 30px 40px;
  }

  #CancelRefund >>> .el-col-24 {
    margin-bottom: 10px;
  }

  #CancelRefund .status {
    color: #00C8B2;
  }

  #CancelRefund .label {
    display: inline-block;
    width: 75px;
  }

  .cancelBtn {
    display: block;
    width: 100%;
    text-align: center;
    line-height: 40px;
    color: #FFFFFF;
    background-color: #00C8B2;
    border-radius: 5px;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    /deep/ .el-dialog {
      width: 90% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/cancel-refund.vue